// extracted by mini-css-extract-plugin
export default {"errorText":"ErrorPopUp_errorText__FR2Vw","active":"ErrorPopUp_active__Ohk7s"};